import React from 'react';
import { Card } from './ui/card';
import { Check } from 'lucide-react';
import { aboutData } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          {/* Image Side */}
          <div className="relative flex justify-center">
            <div className="relative z-10 max-w-md">
              <img
                src="https://customer-assets.emergentagent.com/job_oahu-photo-book/artifacts/q2b4er8l_DSC_1012.JPG"
                alt="Photographer at work"
                className="rounded-2xl shadow-2xl w-full h-[500px] object-cover"
              />
            </div>
            {/* Decorative elements */}
            <div className="absolute -bottom-6 -right-6 w-72 h-72 bg-gradient-to-br from-cyan-400 to-teal-400 rounded-2xl opacity-20 blur-3xl"></div>
            <div className="absolute -top-6 -left-6 w-64 h-64 bg-gradient-to-br from-teal-400 to-cyan-400 rounded-2xl opacity-20 blur-3xl"></div>
          </div>

          {/* Content Side */}
          <div>
            <h2 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">
              About Me
            </h2>
            <h3 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-6">
              {aboutData.title}
            </h3>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              {aboutData.description}
            </p>

            {/* Highlights */}
            <Card className="p-6 bg-gradient-to-br from-slate-50 to-cyan-50/30 border-none shadow-lg">
              <h4 className="text-xl font-semibold text-slate-800 mb-4">Highlights</h4>
              <div className="space-y-3">
                {aboutData.highlights.map((highlight, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-r from-cyan-500 to-teal-500 flex items-center justify-center mt-0.5">
                      <Check className="w-4 h-4 text-white" />
                    </div>
                    <p className="text-slate-700 text-base">{highlight}</p>
                  </div>
                ))}
              </div>
            </Card>

            <div className="mt-8 flex items-center gap-6">
              <div className="text-center">
                <p className="text-4xl font-bold text-cyan-600">300+</p>
                <p className="text-slate-600 text-sm">Weddings</p>
              </div>
              <div className="w-px h-12 bg-slate-300"></div>
              <div className="text-center">
                <p className="text-4xl font-bold text-teal-600">5+</p>
                <p className="text-slate-600 text-sm">Years Experience</p>
              </div>
              <div className="w-px h-12 bg-slate-300"></div>
              <div className="text-center">
                <p className="text-4xl font-bold text-cyan-600">1000+</p>
                <p className="text-slate-600 text-sm">Happy Clients</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
